import type { IProperty } from 'src/services/api/properties/types';

/**
 * The static type icons the table's property column renders (see ``PropertyIcon``),
 * addressable by URL for surfaces that build raw HTML, like Leaflet markers.
 */
const TYPE_ICON_URLS: Record<string, string> = {
    'Apartment Building': '/img/properties/apartment_building.svg',
    'Apartment Floor Plan': '/img/properties/apartment_building.svg',
    'Apartment': '/img/properties/condo.svg',
    'Condo': '/img/properties/condo.svg',
    'House': '/img/properties/house.svg',
    'Room': '/img/properties/room.svg',
    'Townhouse': '/img/properties/townhouse.svg',
    'Community': '/img/properties/community.svg',
};

const DEFAULT_ICON_URL = '/img/properties/house.svg';
const BUILDING_ICON_URL = TYPE_ICON_URLS['Apartment Building'];

export const typeIconUrl = (type: IProperty['type']): string => (
    TYPE_ICON_URLS[type ?? ''] ?? DEFAULT_ICON_URL
);

export const buildingIconUrl = (type: IProperty['type'] | undefined): string => (
    TYPE_ICON_URLS[type ?? 'Apartment Building'] ?? BUILDING_ICON_URL
);
